import { API_DEFAULT } from "src/constants/minutApi"
import { IProfile } from "src/data/homeProfiles/types/homeProfilesTypes"

export const profileEndpointUrl = (profile: IProfile) =>
  `${API_DEFAULT}/profiles/${profile.id}`
